// extracted by mini-css-extract-plugin
export default {"search":"Search_search__E3GZq","searchInput":"Search_searchInput__kPPZE"};